import { sha256 } from 'js-sha256'
const { OrderedMap } = require('js-sdsl')
const appId = 'McYFnQwZ'
const appSecret = '9063933c33bab732f37a67baf98b9570f3dacc9d'

/**
 * 执行网络请求(所有web项目用一个appId和appKey)
 *
 * @param {*} method 请求方式（GET/POST）
 * @param {*} url 请求url
 * @param {*} data  请求数据
 * @param {*} callback 请求回调
 */
export function request (method, url, data, callback) {
  var xhr = new XMLHttpRequest()
  xhr.open(method, url, true)
  xhr.setRequestHeader('Content-Type', 'application/json')
  // 添加签名数据
  setSignParams(xhr, data)
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
      if (xhr.status >= 200 && xhr.status < 300) {
        callback(null, xhr.responseText)
      } else {
        callback(xhr.statusText)
      }
    }
  }
  xhr.send(JSON.stringify(data))
}

/**
 * 上传文件
 * @param {*} files 文件
 * @param {*} url 上传地址
 * @param {*} extraData 额外数据
 * @param {*} callback 回调
 */
export function upload (files, url, extraData, callback) {
  let xhr = new XMLHttpRequest()
  let formData = new FormData()
  if (files != null) {
    // 解析文件数据加入formData
    for (let key in files) {
      formData.append(key, files[key])
    }
  }
  // 解析额外参数加入formData
  for (let key in extraData) {
    formData.append(key, extraData[key])
  }
  xhr.open('POST', url, true)
  // 添加签名数据
  setSignParams(xhr, extraData)
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
      if (xhr.status >= 200 && xhr.status < 300) {
        callback(null, xhr.responseText)
      } else {
        callback(xhr.statusText)
      }
    }
  }
  xhr.send(formData)
}

/**
 * header 中添加签名相关的数据
 * @param {*} xhr 请求
 * @param {*} data 数据
 */
function setSignParams (xhr, data) {
  var timestamp = new Date().getTime().toString()
  xhr.setRequestHeader('appId', appId)
  xhr.setRequestHeader('timestamp', timestamp)
  xhr.setRequestHeader('sign', getSign(data, timestamp))
}

/**
 * 签名算法 SHA256（web+(param+param1)+timestamp+appId+appSecret+web）
 * @param data 网络请求参数
 */
function getSign (data, timestamp) {
  const orderParamMap = new OrderedMap()
  for (var key in data) {
    orderParamMap.setElement(key, data[key])
  }
  let paramsListString = ''
  orderParamMap.forEach(([key, value]) => {
    paramsListString = paramsListString + value
  })
  let signBefore = 'web' + paramsListString + timestamp + appId + appSecret + 'web'
  return sha256(signBefore)
}



// WEBPACK FOOTER //
// ./src/module/network/Network.js